import React, { ReactElement } from 'react';

import { classNames } from 'utils/css';

import { TTextProps } from './Text.types';
import styles from './Text.module.scss';
import { TEXT_COLOR, TEXT_SIZE, TEXT_TAG } from './Text.constants';

function Text({
  as: Element = TEXT_TAG.p,
  color = TEXT_COLOR.primary,
  size = TEXT_SIZE.medium,
  align,
  weight,
  underline,
  children,
  className,
  ...restProps
}: TTextProps): ReactElement {
  const textClassName = classNames(
    styles.text,
    color && styles[color],
    weight && styles[weight],
    size && styles[size],
    align && styles[align],
    underline && styles.underline,
    className && className
  );

  return (
    <Element className={textClassName} data-testid="Text" {...restProps}>
      {children}
    </Element>
  );
}

export default Text;
